import React, { useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import useTyped from "../common/useTyped";

const useStyles = makeStyles((theme) => ({
  headerTitle: {
    color: "#FFF",
    fontWeight: "1000",
    position: "absolute",
    textAlign: "center",
    top: "calc(100vh / 80)",
    width: "100%",
    left: 0,
  },
  hTSm: {
    marginTop: "5%",
    fontSize: "1.4em",
  },
  hTMd: {
    marginTop: 150,
    fontSize: "6em",
  },
}));

const Title = ({ text1, text2 }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  const titleRef = React.useRef(null);
  useTyped(titleRef, {
    strings: [`${text1}<br />${text2}`],
    typeSpeed: 100,
    backSpeed: 30,
    showCursor: true
  });

  return (
    <Typography
      variant="h1"
      className={clsx(classes.headerTitle, {
        [classes.hTMd]: matches,
        [classes.hTSm]: !matches,
      })}
    >
      <span ref={titleRef} />
    </Typography>
  );
};

Title.propTypes = {
  text1: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
};

export default Title;
